var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"navbar"}},[_vm._t("navlist",_vm._l((_vm.navlist),function(item,index){return _c('router-link',{key:index,staticClass:"nav-item",attrs:{"to":item.linkTo}},[_vm._v(" "+_vm._s(item.label)+" ")])}))],2)}
var staticRenderFns = []

export { render, staticRenderFns }